// biome-ignore lint/style/noRestrictedImports: legacy suppression
import { Navigate } from "react-router-dom";

import { useUser } from "src/contexts/user-context";
import { useSpaceContext } from "src/components/spaces";
import { homeRoute } from "./constants";

export const SlugIndex = () => {
  const { slug, isOnboarding } = useUser();
  const { isInSpace } = useSpaceContext();

  // Space-scoped users should be redirected to audiences instead of home
  if (isInSpace) {
    return <Navigate replace to={`/${slug}/audiences`} />;
  }

  if (isOnboarding) {
    return <Navigate replace to={`/${slug}/onboarding`} />;
  }

  return <Navigate replace to={`/${slug}${homeRoute}`} />;
};
